import { createContext, useContext, useEffect, useState } from "react";

const HeadingContext = createContext();

export const HeadingProvider = ({ children }) => {
    const [heading, setHeading] = useState("");
    return (
        <HeadingContext.Provider value={{ heading, setHeading }}>
            {children}
        </HeadingContext.Provider>
    );
};

export const useHeading = () => useContext(HeadingContext);
